<div class="w-full bg-white border-box radius-10 mb-20" [style.border]="isValidated ? '2px solid #28a745' : 'none'"
  style="border-radius: 10px;" id="contact-verif">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center">
      <div>
        <div class="flex gap-10 align-items-center mb-5">
          <img *ngIf="!isValidated" src="assets/square-icon.svg" alt="">
          <img *ngIf="isValidated" src="assets/valid-square-icon.svg" alt="" width="40px">
          <div>
            <p class="no-margin light-blue bold">1. Membres du bureau de vote</p>
            <p class="no-margin dark-gray text-sm">{{assessors.length}} membres</p>
          </div>
        </div>
      </div>
      <app-tag [isValidated]="isValidated"></app-tag>
    </div>

    <div>
      <button (click)="toggleExpand()" class="pointer"
        style="background: none; border: none; cursor: pointer; font-size: 1.5rem; color: #4A90E2;">
        <span [style.transform]="isExpanded ? 'rotate(-90deg)' : 'rotate(90deg)'"
          style="display: inline-block; transition: transform 0.3s;">›</span>
      </button>
    </div>
  </div>


  <div *ngIf="isExpanded" id="information-grid"
    class="p-20">

    <div *ngFor="let assessor of assessors; let i = index" >
      <p class="dark-blue bold no-margin">{{assessor.name}}</p>
      <p class="light-blue text-sm no-margin">{{assessor.email}}</p>
      <div *ngIf="i != assessors.length - 1" class="w-full mb-10 mt-10" style="height: 1px; background-color: #F5F8FF;">
      </div>
    </div>

  </div>
</div>